// Nachrichten des Live-Dienstes an den Browser.
export type LiveMessage = { type: 'line' | 'hint' | 'status'; text: string; speaker?: string; category?: string };

export const liveCategoryLabels: Record<string, string> = {
  EINWAND: 'Einwand',
  FRAGE: 'Frage',
  TERMIN: 'Termin',
  INFO: 'Hinweis',
  PFLICHT: 'Pflichtpunkt',
};

// Nachricht des Browsers an den Live-Dienst: Leitfaden und Pflichtpunkte des Projekts (einmal nach dem Verbinden).
export type LiveGuidelineMessage = {
  type: 'guideline';
  text: string;
  mandatory_points: { key: string; label: string; appointment_only: boolean }[];
};
